export const esTranslations = {
  app_name: 'Balivernología',
  nav: {
    home: 'Inicio',
    investigations: 'Investigaciones',
    investigators: 'Investigadores',
    login: 'Iniciar sesión',
    register: 'Registrarse',
    logout: 'Cerrar sesión',
    streamerAdmin: 'Admin',
    my_profile: 'Mi perfil',
    about: 'Acerca de',
    theme_toggle_to_dark: 'Cambiar a tema oscuro',
    theme_toggle_to_light: 'Cambiar a tema claro',
  },
  home: {
    hero_title: 'Desenmascara las Patrañas',
    hero_subtitle:
      'Investigaciones colaborativas sobre mentiras políticas, retórica manipuladora y desinformación.',
    hero_cta: 'Ver Investigaciones',
    recent_title: 'Investigaciones Recientes',
    see_more: 'Ver Todas las Investigaciones',
    no_investigations: 'Sin investigaciones por el momento.',
    manifesto_quote: 'Cuando las creencias y convicciones importan más que la realidad factual.',
    stats_investigations: 'Investigaciones activas',
    stats_total_investigations: 'Investigaciones en total',
    stats_investigators: 'Investigadores',
    stats_closed_investigations: 'Investigaciones cerradas',
    carousel_prev: 'Anterior',
    carousel_next: 'Siguiente',
    lead_kicker: 'Investigación destacada',
    headlines_title: 'Investigaciones en curso',
    headlines_completed_title: 'Investigaciones terminadas',
    secondary_title: 'Investigaciones recientes',
    latest_title: 'Últimas publicaciones',
    category_section_title: '{{category}}',
    see_all: 'Ver todas las investigaciones',
    breaking_label: 'Última hora',
    empty_state: 'Sin investigaciones por el momento.',
  },
  investigations: {
    title: 'Investigaciones',
    page_title: 'Investigaciones',
    search_placeholder: 'Buscar investigaciones...',
    filter_category: 'Todas las categorías',
    filter_category_label: 'Filtrar por categoría',
    sort_by: 'Ordenar por',
    sort_date: 'Fecha',
    sort_title: 'Título',
    sort_category: 'Categoría',
    no_results: 'No se encontraron investigaciones.',
    view_details: 'Ver detalles',
    leads_count: '{{count}} pista',
    leads_count_plural: '{{count}} pistas',
    suggest_new: 'Sugerir una investigación',
    suggestions_title: 'Investigaciones sugeridas',
    suggestions_subtitle: '¡Vota por las investigaciones que quieres ver!',
    vote: 'Votar',
    voted: 'Votado',
    votes: '{{count}} votos',
    your_suggestion: 'Tu sugerencia',
    suggestion_title_label: 'Título',
    suggestion_description_label: 'Descripción (opcional)',
    suggestion_submit: 'Enviar sugerencia',
    sort_most_voted: 'Más votadas',
    sort_newest: 'Más recientes',
    login_to_vote: 'Inicia sesión para votar',
    login_to_suggest: 'Inicia sesión para sugerir una investigación',
    suggestion_col_title: 'Título',
    suggestion_col_by: 'Enviado por',
    suggestion_col_date: 'Fecha',
    suggestion_col_votes: 'Votos',
    suggestion_empty: 'No hay sugerencias por el momento.',
    tab_active: 'Investigaciones en curso',
    tab_inactive: 'Investigaciones completadas',
  },
  investigators: {
    page_title: 'Investigadores',
    page_subtitle: 'Los miembros de la comunidad que contribuyen a las investigaciones.',
    empty: 'No hay investigadores por el momento.',
    unknown: 'Desconocido',
  },
  investigation_detail: {
    by: 'Por',
    category: 'Categoría',
    leads: 'Pistas',
    no_leads: 'No hay pistas para esta investigación.',
    lead_url: 'URL',
    lead_description: 'Descripción',
    lead_submitted_by: 'Enviado por',
    lead_date: 'Fecha',
    view_lead: 'Ver detalles',
    add_lead_button: 'Añadir pista',
    add_lead_title: 'Enviar una pista',
    add_lead_title_label: 'Título',
    add_lead_title_placeholder: 'Ej.: Nuevo hecho sobre manipulación climática',
    add_lead_description_label: 'Descripción',
    add_lead_description_placeholder: 'Describe brevemente esta pista...',
    add_lead_submit: 'Enviar pista',
    add_lead_success: '¡Pista añadida con éxito!',
    add_lead_login_prompt: 'Inicia sesión para enviar una pista',
    not_found_title: 'Investigación no encontrada',
    not_found_body: 'Esta investigación no existe o ha sido eliminada.',
    team_button: 'Ver el equipo',
    team_modal_title: 'Equipo de investigación',
    team_lead_badge: 'Responsable',
    team_empty: 'No hay miembros en este equipo.',
    notes_title: 'Análisis y síntesis',
    live_label: 'En directo próximamente',
    live_at: 'a las',
    live_replay_label: 'Replay disponible',
    live_watch_twitch: 'Ver en Twitch',
    live_watch_youtube: 'Ver en YouTube',
    live_watch_video: 'Ver el vídeo',
    live_video_label: 'Vídeo asociado',
    live_watch_replay: 'Ver el Replay',
    lead_drag_handle: 'Arrastra la pista para reordenarla',
    lead_reorder_success: 'Orden de pistas actualizado',
    lead_reorder_failed: 'Error al reordenar las pistas: {{error}}',
  },
  investigation_form: {
    public_urls_title: 'Direcciones públicas',
    public_urls_rename_warning:
      'Cambiar el título (o su traducción) cambia la dirección en ese idioma; la dirección anterior redirige automáticamente.',
    public_url_source_fallback: 'Derivada del título original',
    public_url_copy: 'Copiar la dirección',
    public_url_copied: 'Dirección copiada',
    public_url_open: 'Abrir la página',
  },
  lead_detail: {
    title: 'Detalle de la pista',
    description: 'Descripción',
    date: 'Enviado el',
    not_found_title: 'Pista no encontrada',
    not_found_body: 'Esta pista no existe o ha sido eliminada.',
    badge: 'Pista',
    fallback_title: 'Pista',
    facts: 'Hechos',
    no_facts: 'No hay hechos para esta pista.',
    add_fact_button: 'Añadir un hecho',
    add_fact_title: 'Añadir un hecho',
    fact_title_label: 'Título',
    fact_title_placeholder: 'Ej.: Artículo de El País',
    fact_description_label: 'Descripción',
    fact_description_placeholder: 'Describe brevemente este hecho...',
    fact_url_label: 'URL fuente',
    fact_url_placeholder: 'https://...',
    fact_no_source_title: 'Hecho sin fuente',
    fact_no_source_message:
      'No has indicado ninguna URL de fuente para este hecho. Se guardará sin referencia verificable. ¿Deseas continuar?',
    fact_no_source_cancel: 'Añadir una fuente',
    fact_no_source_confirm: 'Guardar sin fuente',
    fact_image_label: 'Imagen (opcional)',
    add_fact_submit: 'Añadir el hecho',
    add_fact_success: '¡Hecho añadido con éxito!',
    add_fact_login_prompt: 'Inicia sesión para añadir un hecho',
    fact_delete_confirm: '¿Eliminar este hecho?',
    fact_deleted: 'Hecho eliminado',
    fact_delete_failed: 'No se pudo eliminar el hecho: {{error}}',
    fact_reset_votes: 'Restablecer votos',
    fact_reset_votes_confirm: '¿Restablecer todos los votos de este hecho?',
    fact_reset_votes_success: 'Votos restablecidos',
    fact_reset_votes_failed: 'Error al restablecer los votos',
    fact_edit_title: 'Editar hecho',
    fact_edit_submit: 'Guardar cambios',
    fact_score_validated_label: 'Puntuación validada',
    fact_score_average_label: 'Puntuación media',
    fact_score_voters: '{{count}} voto(s)',
    fact_score_none: 'Ninguno',
    fact_score_vote_prompt: 'Evalúe el hecho',
    fact_score_your_vote: 'Su evaluación',
    fact_score_validate_updated: 'Puntuación validada actualizada',
    fact_score_validate_success: 'Puntuación validada guardada',
    fact_score_validate_button: 'Validar',
    fact_score_validate_label: 'Validar puntuación',
    fact_score_clear_validated: 'Borrar validación',
    fact_score_validate_error: 'No se pudo actualizar la puntuación validada',
    fact_updated: '¡Hecho actualizado!',
    fact_update_failed: 'No se pudo actualizar el hecho: {{error}}',
    fact_see_more: 'Ver más',
    fact_see_less: 'Ver menos',
    fact_source_button: 'Fuente',
    fact_published: 'Publicado',
    fact_unpublished: 'No publicado',
    fact_publish_button: 'Publicar',
    fact_publish_success: 'Hecho publicado con éxito',
    fact_publish_failed: 'Error al publicar el hecho: {{error}}',
    fact_unpublish_button: 'Retirar la publicación',
    fact_unpublish_success: 'Hecho retirado de la publicación',
    fact_unpublish_failed: 'Error al retirar la publicación: {{error}}',
    fact_drag_handle: 'Arrastrar el hecho para reordenarlo',
    fact_reorder_success: 'Orden de los hechos actualizado',
    fact_reorder_failed: 'No se pudo reordenar los hechos: {{error}}',
    edit_lead: 'Editar pista',
    lead_published: 'Publicada',
    lead_unpublished: 'No publicada',
    lead_publish_button: 'Publicar',
    lead_unpublish_button: 'Retirar la publicación',
    lead_publish_success: 'Pista publicada con éxito',
    lead_publish_failed: 'Error al publicar la pista: {{error}}',
    lead_unpublish_success: 'Pista retirada de la publicación',
    lead_unpublish_failed: 'Error al retirar la publicación: {{error}}',
    notes_title: 'Análisis y síntesis',
    source_title: 'Fuente original',
    source_add_button: 'Añadir fuente',
    source_edit_button: 'Editar fuente',
    source_delete_confirm: '¿Eliminar la fuente?',
    source_deleted: 'Fuente eliminada',
    source_delete_failed: 'No se pudo eliminar la fuente: {{error}}',
    source_dialog_add_title: 'Añadir una fuente',
    source_dialog_edit_title: 'Editar fuente',
    source_title_label: 'Título *',
    source_title_placeholder: 'Ej.: Artículo de El País, informe oficial…',
    source_description_label: 'Descripción *',
    source_description_placeholder: 'Describe brevemente esta fuente…',
    source_image_label: 'Imagen (opcional)',
    source_url_label: 'URL de la fuente *',
    source_url_placeholder: 'https://...',
    source_submit_add: 'Añadir',
    source_submit_edit: 'Guardar',
    source_saved: 'Fuente guardada',
    source_save_failed: 'No se pudo guardar la fuente: {{error}}',
    source_no_source: 'No se ha proporcionado ninguna fuente.',
  },
  auth: {
    login_title: 'Iniciar sesión',
    login_subtitle: 'Accede a tu cuenta de Balivernología',
    register_title: 'Crear cuenta',
    register_subtitle: 'Únete a la comunidad de Balivernología',
    username: 'Nombre de usuario',
    email: 'Correo electrónico',
    password: 'Contraseña',
    display_name: 'Nombre de visualización (opcional)',
    login_button: 'Iniciar sesión',
    register_button: 'Crear cuenta',
    no_account: '¿No tienes cuenta?',
    has_account: '¿Ya tienes cuenta?',
    register_link: 'Regístrate',
    login_link: 'Inicia sesión',
    streamer_login: 'Acceso Streamer',
    // Social login
    social_or: 'o continuar con',
    social_google: 'Continuar con Google',
    social_twitch: 'Continuar con Twitch',
    // 2FA
    two_factor_title: 'Autenticación de dos factores',
    two_factor_subtitle: 'Introduce el código de 6 dígitos de tu aplicación de autenticación.',
    two_factor_code_label: 'Código de autenticación',
    two_factor_code_placeholder: '000000',
    two_factor_verify_button: 'Verificar',
    two_factor_back: 'Volver al inicio de sesión',
    // OAuth callback
    oauth_completing: 'Completando inicio de sesión…',
    oauth_error_title: 'Error de autenticación',
    oauth_error_subtitle: 'Algo salió mal durante el inicio de sesión.',
    oauth_back_to_login: 'Volver al inicio de sesión',
    oauth_error_denied: 'Denegaste el acceso.',
    oauth_error_failed: 'Inicio de sesión fallido. Por favor, inténtalo de nuevo.',
    oauth_error_unknown: 'Ocurrió un error desconocido.',
    oauth_error_no_account: 'No se encontró ninguna cuenta. Por favor, regístrese primero.',
    oauth_error_account_pending: 'Su cuenta está pendiente de activación por un administrador.',
    recaptcha_notice_prefix: 'Este sitio está protegido por reCAPTCHA y aplican la',
    recaptcha_privacy: 'Política de privacidad',
    recaptcha_and: 'y los',
    recaptcha_terms: 'Términos de servicio',
    recaptcha_notice_suffix: 'de Google.',
    register_pending_title: 'Registro pendiente de aprobación',
    register_pending_body:
      'Tu cuenta ha sido creada. Un administrador debe validarla antes de que puedas iniciar sesión.',
  },
  common: {
    loading: 'Cargando...',
    error: 'Ocurrió un error.',
    back: 'Volver',
    by: 'por',
    on: 'el',
    investigation: 'Investigación',
    slide: 'Diapositiva {{number}}',
    refreshing: 'Actualizando...',
    cancel: 'Cancelar',
    created_at: 'Creado el:',
    page_prev: 'Anterior',
    page_next: 'Siguiente',
    page_info: 'Página {{page}} / {{total}}',
    notes_edit: 'Editar',
    notes_add: 'Agregar una nota',
    delete: 'Eliminar',
    submitted_by: 'Enviada por',
    image_enlarge: 'Ampliar la imagen',
    image_enlarge_named: 'Ampliar la imagen: {{alt}}',
    image_preview: 'Vista previa de la imagen',
    image_close: 'Cerrar la imagen',
    back_to_top: 'Volver arriba',
  },
  validation: {
    url_invalid: 'Por favor, introduce una URL válida.',
    required: 'Este campo es obligatorio.',
    max_chars: 'Máximo {{count}} caracteres.',
    comment_empty: 'El comentario no puede estar vacío.',
    comment_max: 'Máximo 2000 caracteres.',
    name_min: 'El nombre debe tener al menos 2 caracteres.',
    name_max: 'El nombre debe tener como máximo 250 caracteres.',
    desc_max: 'La descripción debe tener como máximo 20 000 caracteres.',
    id_min: 'El identificador debe tener al menos 2 caracteres.',
    id_max: 'El identificador debe tener como máximo 200 caracteres.',
    image_url: 'Debe ser una URL válida.',
    username_min: 'Mínimo 3 caracteres.',
    username_max: 'Máximo 30 caracteres.',
    email_invalid: 'Dirección de correo electrónico inválida.',
    password_min: 'Mínimo 8 caracteres.',
    description_required: 'La descripción es obligatoria.',
    account_pending: 'Tu cuenta está pendiente de aprobación por un administrador.',
  },
  editor: {
    bold: 'Negrita',
    italic: 'Cursiva',
    strike: 'Tachado',
    underline: 'Subrayado',
    heading2: 'Título H2',
    heading3: 'Título H3',
    bullet_list: 'Lista con viñetas',
    ordered_list: 'Lista numerada',
    quote: 'Cita',
    code: 'Código',
    insert_image: 'Insertar imagen',
    uploading: 'Subiendo…',
    image_too_large: 'La imagen supera el tamaño máximo permitido (30 MB).',
    image_invalid_type: 'Formato de archivo no compatible (solo JPG, PNG, WebP, GIF).',
    upload_failed: 'Error al subir la imagen. Inténtalo de nuevo.',
    image_resize_hint: 'Una vez insertada, arrastra una esquina de la imagen para redimensionarla.',
    save: 'Guardar',
    cancel: 'Cancelar',
    no_notes: 'Todavía no hay notas.',
  },
  footer: {
    tagline: 'Una iniciativa ciudadana y colaborativa contra la desinformación.',
    rights: '© {{year}} Balivernología. Todos los derechos reservados.',
    rights_year: '© {{year}} Balivernología.',
    rights_reserved: 'Todos los derechos reservados.',
    social_networks: 'Redes sociales',
    legal: {
      title: 'Legal',
      mentions_legales: 'Aviso legal',
      confidentialite: 'Política de privacidad',
      cookies: 'Cookies',
      manage_cookies: 'Gestionar mis preferencias de cookies',
    },
  },
  admin: {
    login_subtitle: 'Gestión de investigaciones',
    login_card_desc: 'Inicia sesión para gestionar tus investigaciones y consultar las pistas',
    login_note:
      '¿Nuevo en {{appName}}? Esta es una aplicación de demostración para streamers de Twitch.',
    login_welcome: 'Bienvenido de nuevo',
    login_twitch_button: 'Iniciar sesión con Twitch',
    login_or: 'o',
    login_terms:
      'Al iniciar sesión, aceptas nuestros Términos de servicio y nuestra Política de privacidad.',
    login_2fa_redirect:
      'Tu cuenta usa la autenticación de dos factores. Por favor, completa el inicio de sesión desde la página de acceso público.',
    settings_subtitle: 'Configura tu espacio {{appName}}',

    // Header / Sidebar
    header_subtitle: 'Gestión de investigaciones',
    header_search_placeholder: 'Buscar pistas… (Intro)',
    sidebar_admin: 'Admin',
    nav_dashboard: 'Panel de control',
    nav_categories: 'Categorías',
    nav_investigations: 'Investigaciones',
    nav_comments: 'Comentarios',
    comments_col_investigation: 'Investigación',
    comments_col_total: 'Comentarios',
    comments_col_pending: 'Pendientes',
    comments_moderate_button: 'Moderar',
    comments_list_empty: 'Sin comentarios por el momento.',
    comments_moderation_title: 'Moderación de comentarios',
    comments_moderation_empty: 'Ningún comentario pendiente de validación.',
    comments_validate: 'Aprobar',
    comments_reject: 'Rechazar',
    comments_validated_toast: 'Comentario aprobado',
    comments_rejected_toast: 'Comentario rechazado',
    nav_leads: 'Pistas',
    nav_live: 'En vivo',
    nav_import_export: 'Import / Export',
    nav_translations: 'Traducciones',
    nav_settings: 'Ajustes',
    nav_profile: 'Perfil',
    // Profile page
    profile_title: 'Mi Perfil',
    profile_subtitle: 'Gestiona la información de tu cuenta',
    profile_info_title: 'Información de la cuenta',
    profile_info_desc: 'Consulta y actualiza tus datos personales',
    profile_username: 'Nombre de usuario',
    profile_role: 'Rol',
    profile_display_name: 'Nombre de visualización',
    profile_display_name_placeholder: 'Cómo quieres ser conocido',
    profile_first_name: 'Nombre',
    profile_first_name_placeholder: 'Tu nombre',
    profile_last_name: 'Apellido',
    profile_last_name_placeholder: 'Tu apellido',
    profile_email: 'E-Mail',
    profile_email_placeholder: 'Tu dirección de correo electrónico',
    profile_email_conflict: 'Esta dirección de correo electrónico ya está en uso',
    profile_avatar_label: 'Foto de perfil',
    profile_bio_label: 'Biografía',
    profile_bio_placeholder: 'Cuéntanos un poco sobre ti… (máx. 140 caracteres)',
    profile_save: 'Guardar cambios',
    profile_save_success: 'Perfil actualizado con éxito',
    profile_save_error: 'No se pudo actualizar el perfil',
    // 2FA management
    profile_2fa_title: 'Autenticación de dos factores',
    profile_2fa_desc:
      'Añade una capa extra de seguridad a tu cuenta con una contraseña de un solo uso basada en el tiempo.',
    profile_2fa_status_enabled: 'Activada',
    profile_2fa_status_disabled: 'Desactivada',
    profile_2fa_enable_btn: 'Activar 2FA',
    profile_2fa_disable_btn: 'Desactivar 2FA',
    profile_2fa_setup_instruction:
      'Escanea este código QR con tu aplicación de autenticación (Google Authenticator, Authy, 1Password…)',
    profile_2fa_manual_entry: 'O introduce este secreto manualmente:',
    profile_2fa_confirm_label: 'Introduce el código de 6 dígitos para confirmar',
    profile_2fa_confirm_placeholder: '000000',
    profile_2fa_confirm_btn: 'Confirmar y activar',
    profile_2fa_disable_instruction:
      'Introduce el código de 6 dígitos de tu aplicación para desactivar la 2FA.',
    profile_2fa_disable_confirm_btn: 'Confirmar y desactivar',
    profile_2fa_cancel: 'Cancelar',
    profile_2fa_enabled_success: 'La autenticación de dos factores ha sido activada en tu cuenta.',
    profile_2fa_disabled_success: 'La autenticación de dos factores ha sido desactivada.',
    profile_2fa_error: 'Código inválido. Por favor, inténtalo de nuevo.',
    // Team management
    team_title: 'Equipo de investigación',
    team_subtitle: 'Gestiona los investigadores de esta investigación',
    team_empty: 'No hay investigadores aún. Añade miembros para colaborar.',
    team_add: 'Añadir investigador',
    team_remove: 'Eliminar',
    team_remove_confirm: '¿Eliminar a este investigador del equipo?',
    team_removed: 'Investigador eliminado',
    team_added: 'Investigador añadido',
    team_add_dialog_title: 'Añadir un investigador',
    team_search_placeholder: 'Buscar por nombre de usuario...',
    team_no_results: 'No se encontraron usuarios',
    // Suggestions
    nav_suggestions: 'Sugerencias',
    suggestions_page_title: 'Investigaciones sugeridas',
    suggestions_page_subtitle:
      'Revisa las sugerencias de la comunidad y conviértelas en investigaciones',
    suggestions_empty_title: 'No hay sugerencias por el momento',
    suggestions_empty_body:
      'Los usuarios pueden sugerir investigaciones desde la página pública de investigaciones.',
    suggestions_col_title: 'Título',
    suggestions_col_description: 'Descripción',
    suggestions_col_votes: 'Votos',
    suggestions_col_by: 'Sugerido por',
    suggestions_col_date: 'Fecha',
    suggestions_approve: 'Aprobar',
    suggestions_delete: 'Eliminar',
    suggestions_delete_confirm: '¿Eliminar esta sugerencia? Esta acción no se puede deshacer.',
    suggestions_deleted: 'Sugerencia eliminada',
    suggestions_delete_failed: 'No se pudo eliminar la sugerencia',
    suggestions_approve_dialog_title: 'Aprobar sugerencia',
    suggestions_approve_dialog_subtitle:
      'Completa los detalles restantes para crear una investigación a partir de esta sugerencia.',
    suggestions_approved: '¡Investigación creada con éxito!',
    suggestions_approve_failed: 'No se pudo crear la investigación',
    suggestions_badge_votes: '{{count}} votos',
    suggestions_no_description: 'Sin descripción',
    // Gestión de investigadores
    nav_investigators: 'Investigadores',
    investigators_page_title: 'Gestión de investigadores',
    investigators_page_subtitle: 'Gestiona las cuentas de usuario y valida los nuevos registros',
    comments_subtitle: 'Moderar los comentarios publicados en las investigaciones.',
    import_export_subtitle: 'Importar y exportar investigaciones, pistas y hechos.',
    investigators_tab_pending: 'Pendiente ({{count}})',
    investigators_tab_all: 'Todos',
    investigators_col_user: 'Usuario',
    investigators_col_email: 'Email',
    investigators_col_role: 'Rol',
    investigators_col_status: 'Estado',
    investigators_col_date: 'Registro',
    investigators_col_actions: 'Acciones',
    investigators_enable: 'Activar',
    investigators_disable: 'Desactivar',
    investigators_enabled: 'Activo',
    investigators_disabled: 'Pendiente',
    investigators_enabled_toast: 'Cuenta activada',
    investigators_disabled_toast: 'Cuenta desactivada',
    investigators_delete_confirm: '¿Eliminar esta cuenta? Esta acción es irreversible.',
    investigators_deleted: 'Usuario eliminado',
    investigators_delete_failed: 'No se pudo eliminar al usuario',
    investigators_role_user: 'usuario',
    investigators_role_admin: 'admin',
    investigators_role_moderator: 'moderador',
    investigators_role_updated: 'Rol actualizado',
    investigators_empty: 'No se encontraron usuarios',
    investigators_pending_empty: 'No hay cuentas pendientes de aprobación',
    logout: 'Cerrar sesión',
    login: 'Iniciar sesión',
    header_title_dashboard: 'Panel de control',
    header_title_investigations: 'Investigaciones',
    header_title_new_investigation: 'Nueva investigación',
    header_title_edit_investigation: 'Editar investigación',
    header_title_investigation_leads: 'Pistas de la investigación',
    header_title_lead_detail: 'Detalle de la pista',
    // Dashboard
    dash_stat_inv_title: 'Total investigaciones',
    dash_stat_inv_desc: 'Crear y gestionar investigaciones para tu stream',
    dash_stat_leads_title: 'Total pistas',
    dash_stat_leads_desc: 'Todas las pistas enviadas por los espectadores',
    dash_stat_activity_title: 'Actividad reciente',
    dash_stat_activity_desc: 'Nuevas pistas en la última hora',
    dash_stat_submitters_title: 'Mejores colaboradores',
    dash_stat_submitters_desc: 'Espectadores únicos que han enviado pistas',
    dash_your_investigations: 'Tus investigaciones',
    dash_add_investigation: '+ Añadir investigación',
    dash_no_investigations:
      'No hay investigaciones creadas. ¡Crea la primera para empezar a recibir pistas!',
    dash_leads_by_investigation: 'Pistas por investigación',
    dash_no_leads:
      'No hay pistas enviadas. Los espectadores pueden enviarlas con el comando !lead.',
    dash_quick_create_title: 'Crear una investigación',
    dash_quick_create_desc: 'Añadir una nueva investigación para recibir pistas',
    dash_quick_leads_title: 'Ver todas las pistas',
    dash_quick_leads_desc: 'Ver todas las pistas enviadas en un solo lugar',
    dash_quick_live_title: 'Vista streamer',
    dash_quick_live_desc: 'Vista en tiempo real de las pistas según llegan',
    // Investigations list
    inv_toggle_activate: 'Marcar como en curso',
    inv_toggle_deactivate: 'Marcar como completada',
    inv_activated: 'Investigación marcada como en curso',
    inv_deactivated: 'Investigación marcada como completada',
    inv_toggle_failed: 'No se pudo cambiar el estado',
    inv_status_active: 'En curso',
    inv_status_inactive: 'Completada',
    inv_status_pending: 'Pendiente',
    inv_filter_status_all: 'Todos los estados',
    inv_filter_status_pending: 'Pendiente',
    inv_filter_status_active: 'Activa',
    inv_filter_status_inactive: 'Inactiva',
    inv_set_status: 'Cambiar estado',
    inv_conclusion_label: 'Conclusión',
    inv_conclusion_none: 'En curso',
    inv_conclusion_true: 'Verdad',
    inv_conclusion_false: 'Falso',
    inv_conclusion_fallacious: 'Falaz',
    inv_conclusion_completed: 'Completado',
    inv_conclusion_success: 'Conclusión guardada',
    inv_conclusion_failed: 'Error al guardar la conclusión: {{error}}',
    inv_conclusion_inactive_note:
      'Establecer una conclusión marca la investigación como completada.',
    lead_conclusion_label: 'Conclusión de la pista',
    lead_conclusion_none: 'En curso',
    lead_conclusion_success: 'Conclusión de la pista guardada',
    lead_conclusion_failed: 'Error al guardar la conclusión de la pista: {{error}}',
    inv_delete_confirm:
      '¿Estás seguro de que quieres eliminar "{{name}}"? También se eliminarán todas las pistas asociadas.',
    inv_deleted: 'Investigación "{{name}}" eliminada con éxito',
    inv_delete_failed: 'No se pudo eliminar la investigación: {{error}}',
    inv_page_title: 'Investigaciones',
    inv_page_subtitle: 'Gestión de las investigaciones',
    inv_empty_title: 'No hay investigaciones creadas',
    inv_empty_body: 'Crea tu primera investigación para empezar a recibir pistas',
    inv_empty_button: 'Crear tu primera investigación',
    inv_card_created: 'Creada el:',
    inv_view_leads: 'Ver pistas',
    inv_leads_page_title: 'Pistas',
    inv_leads_back: 'Volver a investigaciones',
    preview_article: 'Previsualizar',
    inv_leads_add: 'Añadir pista',
    inv_leads_empty_title: 'No hay pistas aún',
    inv_leads_empty_body: 'Añade la primera pista para esta investigación.',
    inv_lead_detail_back: 'Volver a las pistas',
    pagination_info: 'Página {{page}} de {{total}}',
    // Forms (create / edit)
    form_cancel: 'Cancelar',
    form_create_title: 'Crear nueva investigación',
    form_create_subtitle: 'Crear una nueva investigación para que los espectadores envíen pistas',
    form_create_submit: 'Crear investigación',
    form_create_success: 'Investigación "{{name}}" creada con éxito',
    form_create_error: 'No se pudo crear la investigación: {{error}}',
    form_edit_title: 'Editar investigación',
    form_edit_subtitle: 'Actualizar los detalles de esta investigación',
    form_edit_submit: 'Actualizar investigación',
    form_edit_success: 'Investigación "{{name}}" actualizada con éxito',
    form_edit_error: 'No se pudo actualizar la investigación: {{error}}',
    form_name_label: 'Nombre de la investigación *',
    form_name_placeholder: 'Ej.: El Gran Fraude Climático',
    form_name_desc: 'Un nombre único para esta investigación (visible para los espectadores)',
    form_desc_label: 'Descripción',
    form_desc_placeholder: 'Ej.: Consejos y trucos para el desarrollo en React',
    form_desc_helper:
      'Descripción opcional para ayudar a los espectadores a entender la investigación',
    form_id_label: 'Identificador de la investigación *',
    form_id_placeholder: 'Ej.: gran-fraude-climatico',
    form_id_desc: 'Un identificador único para esta investigación (usado en los comandos !lead)',
    form_author_placeholder: 'Ej.: El País, RTVE…',
    form_category_label: 'Categoría',
    form_category_placeholder: 'Ej.: Política, Medios, Ciencia…',
    form_category_desc: 'Categoría mostrada en la página pública de investigaciones',
    form_image_label: 'Imagen de portada',
    form_image_desc: 'Sube un archivo o pega una URL externa (opcional)',
    form_live_section: 'Vídeo asociado',
    form_live_date_label: 'Fecha y hora del directo (opcional)',
    form_live_date_desc: 'Fecha y hora del directo. Dejar vacío para un vídeo simple.',
    form_live_twitch_label: 'Enlace de Twitch',
    form_live_twitch_desc: 'URL del stream de Twitch (opcional).',
    form_live_youtube_label: 'Enlace de YouTube',
    form_live_youtube_desc: 'URL del directo, del replay o de un simple vídeo de YouTube.',
    form_author_label: 'Autor',
    form_author_desc: 'El usuario acreditado como autor de esta investigación',
    form_author_desc_lead: 'El usuario acreditado como autor de esta pista',
    form_author_desc_fact: 'El usuario acreditado como autor de este hecho',
    form_author_search_placeholder: 'Buscar por nombre de usuario o nombre de visualización…',
    form_author_current: 'Autor actual:',
    form_author_clear: 'Eliminar autor',
    form_author_none: 'Ningún autor asignado',
    form_investigation_search_placeholder: 'Buscar una investigación…',
    form_investigation_clear: 'Quitar la investigación vinculada',
    form_investigation_none: 'Ninguna investigación vinculada',
    form_investigation_no_results: 'Ninguna investigación encontrada',
    // Leads list
    leads_title: 'Todas las pistas',
    leads_subtitle: 'Explorar y gestionar todas las pistas enviadas',
    leads_search_placeholder: 'Buscar pistas...',
    leads_all_topics: 'Todas las investigaciones',
    leads_filter_submitter: 'Filtrar por autor...',
    leads_found: '{{count}} pista(s) encontrada(s)',
    leads_empty_title: 'No se encontraron pistas',
    leads_empty_body: 'Prueba a ajustar tus filtros o vuelve más tarde',
    leads_delete_confirm: '¿Estás seguro de que quieres eliminar esta pista?',
    leads_deleted: 'Pista eliminada con éxito',
    leads_delete_failed: 'No se pudo eliminar la pista: {{error}}',
    leads_edit_dialog_title: 'Editar pista',
    leads_edit_title_label: 'Título',
    leads_edit_description_label: 'Descripción',
    leads_edit_image_label: 'Imagen',
    leads_edit_submit: 'Guardar cambios',
    leads_edit_success: 'Pista actualizada con éxito',
    leads_edit_failed: 'No se pudo actualizar la pista: {{error}}',
    // Leads by investigation
    leads_by_inv_not_found: 'Investigación no encontrada',
    leads_by_inv_not_found_body: 'La investigación que buscas no existe.',
    leads_by_inv_view_all: 'Ver todas las investigaciones',
    leads_by_inv_id: 'ID investigación:',
    leads_by_inv_count: '{{count}} pista(s)',
    leads_by_inv_sorted: 'Ordenado por fecha (más antiguo primero)',
    leads_by_inv_empty_title: 'No hay pistas para esta investigación aún',
    leads_by_inv_empty_body: 'Los espectadores pueden enviar pistas con el comando !lead.',
    // LeadGroupList
    lead_group_empty: 'No hay pistas. Los espectadores pueden enviarlas con el comando !lead.',
    lead_group_more: '+{{count}} pistas más',
    lead_group_count: '{{count}} pista(s)',
    // ImageField
    image_upload_aria: 'Subir imagen de portada',
    image_click_replace: 'Clic para reemplazar',
    image_drop_prompt: 'Haz clic o arrastra y suelta para subir',
    image_file_hint: 'JPG, PNG, WebP, GIF · máx. 30 MB',
    image_remove: 'Eliminar imagen',
    image_url_separator: 'o introduce una URL',
    // Live view
    live_title: 'Vista streamer',
    live_subtitle: 'Gestión de los directos',
    live_refresh: 'Actualizar',
    live_auto_on: 'Actualización automática: activada',
    live_auto_off: 'Actualización automática: desactivada',
    live_filter_label: 'Filtrar por investigación:',
    live_all_investigations: 'Todas las investigaciones ({{count}} pistas)',
    live_topic_leads: '{{count}} pista(s)',
    live_oldest_first: 'Más antiguo primero',
    live_newest_first: 'Más reciente primero',
    live_stat_total_leads: 'Total pistas',
    live_stat_active: 'Investigaciones activas',
    live_stat_submitters: 'Colaboradores únicos',
    live_tab_by_investigation: 'Por investigación',
    live_tab_all: 'Todas las pistas',
    live_empty_title: 'No hay pistas aún',
    live_empty_body: 'Los espectadores pueden enviar pistas con el comando !lead.',
    live_no_ongoing_title: 'No hay investigaciones en curso',
    live_no_ongoing_body:
      'Marca investigaciones como en curso en la página de gestión para verlas aquí.',
    live_all_leads_title: 'Todas las pistas ({{count}})',
    live_no_leads: 'No se han enviado pistas aún',
    live_original_source_badge: 'Original',
    live_refreshed: 'Actualizado con éxito',
    live_refresh_failed: 'No se pudo actualizar',
    // Active investigation / lead
    live_bot_panel_title: 'Bot Twitch',
    live_bot_panel_show: 'Mostrar',
    live_bot_panel_hide: 'Ocultar',
    live_active_section_title: 'Contexto activo',
    live_active_investigation_label: 'Investigación activa',
    live_no_active_investigation:
      'Sin investigación activa. Haz clic en "Activar" en una investigación a continuación.',
    live_active_lead_label: 'Pista activa',
    live_no_active_lead: 'No hay pistas para esta investigación aún.',
    live_active_fact_label: 'Hecho activo',
    live_no_active_fact: 'Sin hecho activo.',
    live_set_active_investigation: 'Activar',
    live_set_active_lead: 'Activar pista',
    live_active_badge: 'Activa',
    live_active_lead_badge: 'Pista activa',
    live_active_fact_badge: 'Hecho activo',
    live_set_active_fact: 'Definir como hecho activo',
    live_unset_active_fact: 'Quitar el hecho activo',
    live_active_fact_set: 'Hecho activo definido',
    live_active_fact_cleared: 'Hecho activo eliminado',
    live_active_fact_failed: 'No se pudo actualizar el hecho activo',
    live_commands_reference: 'Comandos de chat',
    // Settings
    settings_title: 'Ajustes',
    settings_profile_title: 'Perfil',
    settings_profile_desc: 'Gestiona los ajustes de tu perfil y preferencias',
    settings_profile_placeholder:
      'Los ajustes de perfil estarán disponibles en una próxima actualización.',
    settings_twitch_title: 'Conexión del bot Twitch',
    settings_twitch_desc:
      'Autentica el bot de chat a través de Twitch OAuth. Los tokens se almacenan en la base de datos y se actualizan automáticamente, sin más comandos manuales.',
    settings_commands_title: 'Comandos de chat disponibles',
    settings_notif_title: 'Notificaciones',
    settings_notif_desc: 'Configura cómo recibes las notificaciones',
    settings_notif_placeholder:
      'Los ajustes de notificación estarán disponibles en una próxima actualización.',
    settings_tech_title: 'Tecnologías',
    // Site identity (white-label)
    settings_site_title: 'Identidad del sitio',
    settings_site_card_desc: 'Personaliza el nombre, la descripción y el tema de tu sitio',
    settings_site_name_label: 'Nombre del sitio',
    settings_site_name_placeholder: 'Ej.: Mi sitio de investigaciones',
    settings_site_description_label: 'Descripción',
    settings_site_description_placeholder: 'Una breve descripción de tu sitio',
    settings_theme_label: 'Tema (usuarios conectados)',
    settings_theme_desc:
      'Apariencia aplicada para ti una vez conectado, tanto en la administración como en las páginas públicas tal como las ves.',
    settings_public_theme_label: 'Tema público (visitantes anónimos)',
    settings_public_theme_desc:
      'Apariencia que ven los visitantes anónimos en las páginas públicas del sitio.',
    settings_site_save_button: 'Guardar',
    settings_site_saved: 'Configuración del sitio guardada',
    settings_homepage_layout_label: 'Diseño de la página de inicio',
    settings_homepage_layout_classic: 'Clásico',
    settings_homepage_layout_news: 'Portada de noticias',
    // Social networks
    settings_social_title: 'Redes sociales',
    settings_social_card_desc:
      'Configura los enlaces a tus redes sociales que aparecen en la página Acerca de',
    settings_social_save_button: 'Guardar',
    settings_social_saved: 'Redes sociales guardadas',
    settings_social_x_label: 'X (antes Twitter)',
    settings_social_bluesky_label: 'BlueSky',
    settings_social_facebook_label: 'Facebook',
    settings_social_instagram_label: 'Instagram',
    settings_social_tiktok_label: 'TikTok',
    settings_social_youtube_label: 'YouTube',
    settings_social_twitch_label: 'Twitch',
    settings_social_discord_label: 'Discord',
    settings_social_footer_links_title: 'Enlaces del pie de página',
    settings_social_footer_links_desc:
      'Selecciona hasta 6 redes para mostrar en el pie de página (solo las redes con una URL configurada pueden activarse).',
    // Breaking news banner
    settings_breaking_title: 'Barra de última hora',
    settings_breaking_card_desc: 'Configura la barra de última hora de la portada de noticias',
    settings_breaking_active_label: 'Activa',
    settings_breaking_message_label: 'Mensaje',
    settings_breaking_investigation_label: 'Investigación vinculada (opcional)',
    settings_breaking_link_mode_label: 'Enlace del banner',
    settings_breaking_link_mode_none: 'Ninguno',
    settings_breaking_link_mode_investigation: 'Investigación vinculada',
    settings_breaking_link_mode_link: 'Enlace personalizado',
    settings_breaking_link_label: 'Enlace personalizado',
    settings_breaking_save_button: 'Guardar',
    settings_breaking_saved: 'Configuración de última hora guardada',
    // Language selector
    settings_lang_section_title: 'Idioma para los parámetros',
    settings_lang_section_desc: 'Define la configuración del sitio para cada idioma disponible.',
    twitch_checking: 'Verificando conexión…',
    twitch_connected_as: 'Conectado como',
    twitch_expires_in: 'expira en {{minutes}} min',
    twitch_expired: 'Token expirado para @{{username}} — se requiere nueva autenticación',
    twitch_not_connected: 'Bot no conectado',
    twitch_disconnect: 'Desconectar el bot',
    twitch_reauthenticate: 'Volver a autenticar el bot',
    twitch_connect: 'Conectar el bot con Twitch',
    twitch_language_label: 'Idioma del bot',
    twitch_language_en: '🇬🇧 Inglés',
    twitch_language_fr: '🇫🇷 Francés',
    twitch_language_desc:
      'Todos los mensajes del bot en el chat de Twitch (bienvenida, comandos, anuncios) usarán este idioma.',
    twitch_language_saved: 'Idioma guardado.',
    bot_send_welcome: 'Enviar mensaje de bienvenida',
    bot_send_welcome_desc:
      'Envía la introducción del bot y la lista de comandos a todos los chats conectados.',
    bot_welcome_sent: 'Mensaje de bienvenida enviado.',
    twitch_connected_toast: '¡Bot @{{username}} conectado con éxito!',
    twitch_connected_generic: '¡Bot Twitch conectado con éxito!',
    twitch_denied: 'La autorización de Twitch fue denegada.',
    youtube_checking: 'Comprobando el estado de YouTube...',
    youtube_connected_as: 'Conectado como',
    youtube_expires_in: 'Expira en {{minutes}} min',
    youtube_expired: 'Token expirado para {{username}}',
    youtube_not_connected: 'Bot de YouTube no conectado',
    youtube_disconnect: 'Desconectar el bot',
    youtube_connect: 'Conectar el bot de YouTube',
    youtube_reauthenticate: 'Reconectar el bot de YouTube',
    // Delete account (Danger Zone)
    profile_delete_title: 'Eliminar cuenta',
    profile_delete_desc: 'Elimina permanentemente tu cuenta y todos los datos asociados.',
    profile_delete_warning:
      'Esto eliminará permanentemente tu perfil, tus comentarios y tus votos de sugerencias. Tus investigaciones, pistas y sugerencias se conservarán y reasignarán al streamer. Esta acción no se puede deshacer.',
    profile_delete_btn: 'Eliminar mi cuenta…',
    profile_delete_confirm_label: 'Para confirmar, escribe tu nombre de usuario a continuación:',
    profile_delete_confirm_placeholder: 'Tu nombre de usuario',
    profile_delete_confirm_btn: 'Sí, eliminar permanentemente',
    profile_delete_cancel: 'Cancelar',
    profile_delete_success: 'Tu cuenta ha sido eliminada permanentemente.',
    profile_delete_error: 'No se pudo eliminar la cuenta. Por favor, inténtalo de nuevo.',
  },
  about: {
    title: 'Acerca de',
    description:
      '{{appName}} es una plataforma de investigación ciudadana y colaborativa contra la desinformación.',
    follow_us: 'Síguenos en',
  },
  read_mode: {
    print: 'Imprimir',
    share: 'Compartir',
    share_facebook: 'Compartir en Facebook',
    share_x: 'Compartir en X',
    share_bluesky: 'Compartir en Bluesky',
    toc_title: 'En esta investigación',
    source_label: 'Fuente original',
    notes_label: 'Análisis y síntesis',
    facts_title: 'Hechos',
    no_facts: 'Aún no hay hechos para esta pista.',
    by: 'Por',
    comments_link: 'Comentarios',
    reading_time_one: '{{count}} minuto',
    reading_time_other: '{{count}} minutos',
    preview_banner: 'Estás viendo una vista previa que incluye contenido no publicado.',
    preview_banner_public: 'Estás viendo la versión pública, que solo incluye contenido publicado.',
    preview_banner_view_public: 'Ver versión publicada',
    preview_banner_view_preview: 'Volver a la vista previa',
    listen: {
      region_label: 'Reproductor de audio del artículo',
      cta: 'Escuchar el artículo',
      duration_one: '{{count}} min',
      duration_other: '{{count}} min',
      play_label: 'Escuchar el artículo, {{duration}}',
      pause: 'Pausar',
      resume: 'Reanudar',
      replay: 'Volver a escuchar',
      stop: 'Detener',
      seek_label: 'Posición de reproducción',
      position_text: '{{elapsed}} de {{total}}',
      speed_label: 'Velocidad: {{rate}}×',
      more_options: 'Opciones de reproducción',
      voice_label: 'Voz',
      voice_auto: 'Automática',
      voice_quality_high: 'Natural',
      voice_low_quality_hint: 'Voz del sistema de calidad limitada',
      now_listening: 'Escuchando',
      status_playing: 'Reproduciendo',
      status_paused: 'En pausa',
      status_ended: 'Terminado',
      error: 'Reproducción interrumpida',
      retry: 'Reintentar',
      minutes_seconds: '{{m}} min {{s}} s',
      preparing: 'Preparando la voz…',
      preparing_percent: 'Descargando la voz… {{percent}} %',
      consent_title: 'Voz del sitio',
      consent_body:
        'Voz del sitio: descarga de ~{{size}} MB por idioma, una sola vez. Las mismas voces en todos los dispositivos.',
      consent_download: 'Descargar',
      consent_device: 'Usar la voz del dispositivo',
      engine_label: 'Motor de voz',
      engine_site: 'Voz del sitio',
      engine_device: 'Voz del dispositivo',
      engine_device_unavailable: 'No hay voz del dispositivo para este idioma',
      active_voice: 'Voz activa: {{name}}',
      active_voice_device: 'Voz activa: voz del dispositivo',
      credits_link: 'Créditos de audio',
      fallback_notice: 'No se pudo cargar la voz del sitio: se usa la voz del dispositivo.',
    },
  },
  article_comments: {
    title: 'Comentarios',
    no_comments: '¡Sin comentarios aún. Sé el primero!',
    placeholder: 'Comparte tus ideas...',
    submit: 'Publicar',
    login_to_comment: 'Inicia sesión para comentar',
    login_to_reply: 'Inicia sesión para responder',
    reply: 'Responder',
    reply_placeholder: 'Escribe tu respuesta...',
    reply_submit: 'Publicar respuesta',
    cancel_reply: 'Cancelar',
    pending: 'Pendiente de validación',
    approve: 'Aprobar',
    edit: 'Editar',
    delete: 'Eliminar',
    edit_dialog_title: 'Editar comentario',
    edit_submit: 'Guardar',
    approved_toast: 'Comentario aprobado',
    deleted_toast: 'Comentario eliminado',
    updated_toast: 'Comentario actualizado',
    delete_confirm: '¿Eliminar este comentario?',
    my_pending_note: 'Tu comentario está pendiente de validación',
    published_toast: '¡Comentario publicado!',
    reply_published_toast: '¡Respuesta publicada!',
    moderate_validate: 'Validar',
    moderate_reject: 'Rechazar',
  },
  pwa_install: {
    title: 'Instala Balivernologie en tu pantalla de inicio',
    description:
      'Añade la aplicación a tu pantalla de inicio para acceder con un toque, a pantalla completa e incluso sin conexión.',
    ios_step_share: 'Pulsa Compartir, en la barra inferior del navegador.',
    ipados_step_share: 'Pulsa Compartir, en la barra superior del navegador.',
    ios_step_more: 'Luego «Ver más», para ver toda la lista.',
    ios_step_add: 'Luego «Añadir a pantalla de inicio», y confirma con «Añadir».',
    android_step_menu: 'Abre el menú del navegador, arriba a la derecha.',
    android_step_add: 'Elige «Añadir a pantalla de inicio» y confirma.',
    install_action: 'Instalar la aplicación',
    dismiss: 'No, gracias',
    close: 'Cerrar la invitación',
  },
  audio_credits: {
    page_title: 'Créditos de audio',
    intro:
      'La función «Escuchar el artículo» utiliza voces sintéticas que se descargan una sola vez en su navegador, con su consentimiento, y se ejecutan localmente: ningún texto se envía a un servidor.',
    voices_title: 'Voces',
    voice_license: 'Licencia',
    voice_credit: 'Crédito',
    voice_source:
      'Los modelos de voz proceden del repositorio de Hugging Face rhasspy/piper-voices, en la revisión {{revision}}.',
    piper_title: 'Piper',
    piper_body:
      'La síntesis de voz se basa en Piper (rhasspy/piper, licencia MIT). La ejecución en el navegador utiliza piper-wasm de Diffusion Studio (licencia MIT) y se inspira en piper-tts-web de Mintplex Labs (licencia MIT).',
    espeak_title: 'eSpeak NG',
    espeak_body:
      'La fonetización del texto utiliza eSpeak NG, distribuido bajo la licencia GNU GPL versión 3 o posterior. Su código fuente está disponible en:',
    onnx_title: 'ONNX Runtime Web',
    onnx_body:
      'Los modelos se ejecutan con ONNX Runtime Web (Microsoft, licencia MIT), compilado a WebAssembly.',
  },
  cookies: {
    banner_title: 'Respetamos su privacidad',
    banner_description:
      'Utilizamos una cookie estrictamente necesaria para recordar su elección de consentimiento y, únicamente con su acuerdo, una categoría para contenidos multimedia de terceros integrados.',
    banner_privacy_link: 'Más información en nuestra política de privacidad',
    accept_all: 'Aceptar todo',
    refuse_all: 'Rechazar todo',
    customize: 'Personalizar',
    preferences_title: 'Preferencias de cookies',
    preferences_description:
      'Elija las categorías de cookies y de almacenamiento local que autoriza. Puede modificar esta elección en cualquier momento desde el enlace «Cookies» en el pie de página.',
    category_necessary_title: 'Estrictamente necesarias',
    category_necessary_description:
      'Necesarias para registrar su propia elección de consentimiento. Siempre activas — no se pueden desactivar.',
    category_media_title: 'Contenidos multimedia de terceros',
    category_media_description:
      'Permite mostrar contenidos integrados de servicios de terceros como YouTube, Vimeo o mapas. Desactivada de forma predeterminada.',
    save_preferences: 'Guardar preferencias',
    embed_blocked:
      'Este contenido requiere su consentimiento a los medios de terceros integrados para cargarse.',
    embed_blocked_named:
      'Este contenido de {{service}} requiere su consentimiento a los medios de terceros integrados para cargarse.',
    embed_accept: 'Aceptar y cargar el contenido',
    page_title: 'Política de cookies',
    page_intro:
      'Esta página explica qué es una cookie, cuáles utilizamos, por qué, durante cuánto tiempo, y cómo puede modificar su elección en cualquier momento.',
    page_what_is_title: '¿Qué es una cookie?',
    page_what_is_body:
      'Una cookie (o una entrada equivalente de almacenamiento local) es un pequeño dato guardado por su navegador al visitar un sitio web. Puede utilizarse para recordar información, como sus preferencias o una elección realizada, de una visita a otra.',
    page_what_we_use_title: 'Qué utilizamos, y por qué',
    page_categories_intro:
      'Utilizamos exactamente dos categorías de cookies/almacenamiento local, ni una más:',
    page_category_necessary:
      'Estrictamente necesarias — una única entrada localStorage propia (first-party) que registra la propia elección de consentimiento (qué categorías aceptó, cuándo, y qué versión de esta política). Sin ella no sabríamos que ya respondió, y el aviso volvería a aparecer en cada visita. Esta categoría no es desactivable, ya que es lo que hace posibles sus demás elecciones.',
    page_category_media:
      'Contenidos multimedia de terceros — reservada para futuros contenidos de terceros integrados (por ejemplo, YouTube, Vimeo, mapas interactivos) que puedan añadirse al sitio. Nada de estos servicios se carga hasta que usted da su consentimiento explícito, ya sea desde el aviso, el panel de preferencias, o el botón «aceptar y cargar» que se muestra directamente sobre un contenido bloqueado.',
    page_first_third_title: 'Propias (first-party) frente a terceros (third-party)',
    page_first_third_body:
      'El registro de consentimiento en sí es propio (almacenado únicamente en su navegador, únicamente para este sitio). La categoría «contenidos multimedia de terceros», una vez aceptada, permite que un contenido servido directamente por un proveedor externo (por ejemplo, YouTube) se cargue en la página — ese proveedor puede entonces instalar sus propias cookies, regidas por su propia política.',
    page_duration_title: '¿Cuánto dura el consentimiento?',
    page_duration_body:
      'Su elección de consentimiento se conserva durante 6 meses. Transcurrido ese plazo, caduca automáticamente y el aviso se muestra de nuevo para que pueda confirmar o cambiar su elección. También se restablece cada vez que esta política de cookies cambia de forma que requiera volver a pedirle su consentimiento.',
    page_change_title: 'Cambiar su elección',
    page_change_body:
      'Puede consultar o cambiar sus preferencias en cualquier momento haciendo clic en el botón siguiente, o mediante el enlace «Cookies» presente en el pie de página de cada página.',
    page_change_button: 'Gestionar mis preferencias de cookies',
    page_browser_title: 'Controles del navegador',
    page_browser_body:
      'Independientemente de la herramienta de consentimiento de este sitio, su navegador le permite consultar, eliminar o bloquear las cookies y el almacenamiento local en general — consulte los ajustes o la ayuda de su navegador para conocer los pasos exactos, ya que varían según el navegador y su versión.',
  },
  legal: {
    mentions: {
      page_title: 'Aviso legal',
      publisher_title: 'Editor del sitio',
      publisher_body:
        'Este sitio está editado por Bertrand PRESLES, actuando a título individual y no profesional. Al tratarse de un proyecto personal y no comercial, no se aplica número SIRET/RCS, capital social ni número de IVA.',
      publisher_address_label: 'Dirección',
      publisher_address_value: '18 Bis Rue du Petit Village, 44800 Saint-Herblain, Francia',
      director_title: 'Director de la publicación',
      director_body: 'Bertrand PRESLES.',
      contact_title: 'Contacto',
      contact_body: 'Para cualquier pregunta relativa a este sitio, puede escribir a:',
      host_title: 'Alojamiento',
      host_frontend_label: 'Sitio web (frontend) alojado por',
      host_frontend_value: 'Vercel Inc., 340 S Lemon Ave #4133, Walnut, CA 91789, Estados Unidos',
      host_frontend_site: 'https://vercel.com',
      host_backend_label: 'Backend de la aplicación (API) alojado por',
      host_backend_value:
        'Koyeb — servicio propiedad de Mistral AI (SIREN 952 418 325), 15 rue des Halles, 75001 París, Francia. La sociedad Koyeb (SIREN 850 183 948) fue objeto de una transmisión universal de patrimonio a favor de Mistral AI y fue dada de baja en el registro mercantil el 12 de mayo de 2026.',
      host_backend_site: 'https://www.koyeb.com',
      host_database_label: 'Base de datos alojada por',
      host_database_value:
        'Neon — base de datos PostgreSQL alojada en el Reino Unido (Londres), en AWS.',
      host_database_site: 'https://neon.com',
      host_note:
        'Consulte la política de privacidad para conocer los detalles de las transferencias de datos y las garantías aplicables a cada uno de estos encargados del tratamiento.',
    },
    privacy: {
      page_title: 'Política de privacidad',
      intro_title: 'Introducción',
      intro_body:
        'Esta política de privacidad explica qué datos personales recopila Balivernología, por qué, sobre qué base legal, durante cuánto tiempo, con quién pueden compartirse, y qué derechos tiene sobre ellos, de conformidad con el RGPD.',
      controller_title: 'Responsable del tratamiento',
      controller_body:
        'El responsable del tratamiento es Bertrand PRESLES, que explota este sitio a título individual y no profesional. Puede ejercer sus derechos o formular cualquier pregunta escribiendo a:',
      data_title: 'Qué datos recopilamos, y por qué',
      data_intro:
        'Solo recopilamos los datos que usted proporciona directamente al crear una cuenta, enviar contenido o interactuar con el sitio. No utilizamos cookies analíticas ni publicitarias, y no recopilamos direcciones IP, huellas de navegador ni cookies de sesión/seguimiento.',
      data_account_title: 'Datos de la cuenta',
      data_account_body:
        'Al crear una cuenta: nombre de usuario, dirección de correo electrónico (opcional), una contraseña cifrada de forma segura (nunca almacenada en texto plano — no aplicable para cuentas creadas mediante Google o Twitch), foto de perfil, una breve biografía, su rol, y — si lo activa — la configuración de autenticación de dos factores (TOTP). Si inicia sesión con Google o Twitch, también almacenamos el identificador de cuenta correspondiente proporcionado por ese proveedor. Se almacena un token de renovación de sesión cifrado para mantener su sesión iniciada, válido durante 7 días.',
      data_public_activity_title: 'Contribuciones públicas',
      data_public_activity_body:
        'Los comentarios, pistas, hechos y sugerencias de investigación que envíe se almacenan junto con su nombre de usuario público para poder mostrarse y atribuirse en el sitio. Los comentarios requieren una cuenta — no recopilamos comentarios anónimos o de invitados, y no registramos ninguna dirección de correo electrónico ni dirección IP junto a un comentario.',
      data_uploads_title: 'Imágenes subidas',
      data_uploads_body:
        'Las imágenes que suba se almacenan directamente en nuestra base de datos, junto con un identificador de la cuenta que las subió.',
      data_recaptcha_title: 'Seguridad del registro (reCAPTCHA)',
      data_recaptcha_body:
        'El registro de una cuenta está protegido por Google reCAPTCHA v3 para limitar los abusos automatizados. El token de reCAPTCHA se verifica directamente con Google; no almacenamos ni transmitimos su dirección IP como parte de esta verificación.',
      legal_basis_title: 'Base legal de los tratamientos',
      legal_basis_account:
        'Creación de cuenta, autenticación y visualización de sus contribuciones públicas: ejecución del contrato que celebra al crear una cuenta (RGPD art. 6.1.b).',
      legal_basis_media:
        'Carga de contenidos multimedia de terceros: su consentimiento explícito (RGPD art. 6.1.a), consulte la política de cookies.',
      legal_basis_recaptcha:
        'Prevención de abusos durante el registro mediante reCAPTCHA: nuestro interés legítimo en proteger el servicio frente a abusos automatizados (RGPD art. 6.1.f).',
      retention_title: 'Períodos de conservación',
      retention_body:
        'Como compromiso de política (la conservación aún no está automatizada en nuestros sistemas): los datos de la cuenta se conservan mientras su cuenta permanezca activa, y puede solicitar su eliminación en cualquier momento contactándonos — vea «Sus derechos» a continuación. Las contribuciones públicas (comentarios, pistas, hechos, sugerencias) pueden conservarse para el registro histórico de una investigación incluso después de eliminar su cuenta, aunque el nombre de usuario mostrado puede anonimizarse a petición.',
      recipients_title: 'Con quién se comparten sus datos',
      recipients_intro:
        'Sus datos solo se comparten con los proveedores técnicos estrictamente necesarios para el funcionamiento del sitio, todos actuando como encargados del tratamiento, además de los proveedores de identidad que usted elija para iniciar sesión:',
      recipients_vercel: 'Vercel Inc. (Estados Unidos) — aloja el frontend del sitio web.',
      recipients_koyeb:
        'Koyeb (servicio propiedad de Mistral AI, 15 rue des Halles, 75001 París, Francia) — aloja el backend de la aplicación (servidor). Más detalles sobre su papel como encargado del tratamiento están disponibles en su propio sitio.',
      recipients_neon:
        'Neon — aloja la base de datos PostgreSQL donde se almacenan los datos de cuenta y contenido, alojada en el Reino Unido (Londres), en AWS. Más detalles sobre su papel como encargado del tratamiento están disponibles en su propio sitio.',
      recipients_google:
        'Google — proporciona el inicio de sesión opcional «Iniciar sesión con Google» y la verificación anti-abuso reCAPTCHA.',
      recipients_twitch:
        'Twitch — proporciona el inicio de sesión opcional «Iniciar sesión con Twitch», y opera el bot de chat utilizado para enviar pistas/hechos desde el chat de la emisión.',
      transfers_title: 'Transferencias internacionales de datos',
      transfers_body:
        'La base de datos (Neon) está alojada en el Reino Unido (Londres), en AWS. El Reino Unido cuenta con una decisión de adecuación de la Comisión Europea en virtud del artículo 45 del RGPD, que reconoce su nivel de protección de datos como equivalente al de la UE, por lo que esta transferencia no requiere una garantía adicional por este motivo. Vercel (alojamiento del frontend) y Google (autenticación, reCAPTCHA) tienen su sede en Estados Unidos; para esas transferencias fuera del Espacio Económico Europeo, nos basamos en garantías adecuadas como las cláusulas contractuales tipo y/o el Marco de Protección de Datos UE-EE. UU. (Data Privacy Framework), cuando resulte aplicable. El proveedor del backend (Koyeb, servicio propiedad de Mistral AI) es una sociedad francesa establecida en la Unión Europea; no obstante, la región de procesamiento efectiva de sus servidores no está confirmada por el momento.',
      rights_title: 'Sus derechos',
      rights_intro:
        'De conformidad con el RGPD, dispone de los siguientes derechos sobre sus datos personales, ejercitables escribiéndonos a la dirección de contacto indicada anteriormente:',
      rights_access: 'Derecho de acceso a sus datos personales.',
      rights_rectification: 'Derecho de rectificación de datos inexactos o incompletos.',
      rights_erasure: 'Derecho de supresión («derecho al olvido»).',
      rights_restriction: 'Derecho a la limitación del tratamiento.',
      rights_portability: 'Derecho a la portabilidad de los datos.',
      rights_objection: 'Derecho de oposición al tratamiento basado en el interés legítimo.',
      rights_withdraw_consent:
        'Derecho a retirar su consentimiento en cualquier momento, cuando el tratamiento se base en el consentimiento.',
      complaint_title: 'Derecho a presentar una reclamación',
      complaint_body:
        'Si considera que no se respetan sus derechos en materia de protección de datos, puede presentar una reclamación ante la autoridad francesa de protección de datos (CNIL):',
      complaint_address: '3 Place de Fontenoy, TSA 80715, 75334 Paris Cedex 07, Francia',
      complaint_website: 'https://www.cnil.fr',
    },
  },
  seo: {
    home_title:
      'Patrañología - Investigaciones y verificación de hechos para desenmascarar patrañas',
    home_description:
      'Investigaciones ciudadanas de verificación de hechos: desmontamos rumores y desinformación, con fuentes. Investigaciones en curso, método abierto y verificable.',
    investigations_title: 'Investigaciones',
    investigations_description:
      'Explore todas las investigaciones de verificación de hechos realizadas por la comunidad de Balivernología, activas o cerradas.',
    investigators_title: 'Investigadores',
    investigators_description:
      'Conozca a la comunidad de investigadores que aportan hechos y pistas a Balivernología.',
    about_title: 'Acerca de',
    about_description:
      'Conozca Balivernología, una plataforma ciudadana y colaborativa de lucha contra la desinformación.',
    mentions_legales_title: 'Aviso legal',
    mentions_legales_description:
      'Identidad del editor e información de alojamiento de Balivernología.',
    confidentialite_title: 'Política de privacidad',
    confidentialite_description:
      'Cómo Balivernología recopila, utiliza y protege sus datos personales.',
    cookies_title: 'Política de cookies',
    cookies_description: 'Qué cookies utiliza Balivernología y cómo gestionar sus preferencias.',
    audio_credits_title: 'Créditos de audio',
    audio_credits_description:
      'Voces, licencias y software libre utilizados por la función «Escuchar el artículo».',
  },
  categories: {
    page_title: 'Categorías',
    page_subtitle: 'Gestione las categorías y sus etiquetas en cada idioma.',
    filter_placeholder: 'Filtrar por nombre',
    add_button: 'Añadir',
    add_title: 'Añadir una categoría',
    edit_title: 'Editar la categoría',
    label_fr: 'Francés',
    label_en: 'Inglés',
    label_es: 'Español',
    label_fr_placeholder: 'Ej.: Politique',
    label_en_placeholder: 'Ej.: Politics',
    label_es_placeholder: 'Ej.: Política',
    col_usage: 'Investigaciones',
    col_actions: 'Acciones',
    empty: 'No se encontraron categorías.',
    add_submit: 'Añadir',
    save: 'Guardar',
    create_success: 'Categoría añadida.',
    update_success: 'Categoría modificada.',
    delete_success: 'Categoría eliminada.',
    delete_confirm: '¿Eliminar esta categoría?',
    delete_in_use:
      'Esta categoría la usan {{count}} investigación(es). Elija una categoría de reemplazo a la que reasignarlas antes de eliminarla.',
    delete_reassign_label: 'Categoría de reemplazo',
    delete_reassign_filter: 'Filtrar categorías por nombre',
    delete_reassign_empty: 'Ninguna categoría coincide.',
    edit_aria: 'Editar la categoría {{name}}',
    delete_aria: 'Eliminar la categoría {{name}}',
  },
  taxonomy: {
    search_label: 'Buscar o crear una categoría',
    suggestions_label: 'Sugerencias de categorías',
    suggestions_popular: 'Categorías más usadas',
    suggestions_count_one: '{{count}} sugerencia disponible',
    suggestions_count_other: '{{count}} sugerencias disponibles',
    usage_count_one: '{{count}} investigación',
    usage_count_other: '{{count}} investigaciones',
    no_results: 'No se encontró ninguna categoría.',
    create_term: 'Crear «{{name}}»',
    creating: 'Creando…',
    create_error: 'No se pudo crear la categoría «{{name}}»: {{message}}',
    remove_term: 'Quitar la categoría {{label}}',
    untranslated_badge_title:
      'Aún sin traducir: se muestra el nombre en {{locale}} hasta que exista una etiqueta.',
    label_input_aria: 'Etiqueta de «{{name}}» en {{locale}}',
    labels_shared_hint:
      'Una etiqueta se aplica a todas las investigaciones que usan esta categoría, no solo a esta.',
    canonical_name_hint: 'Nombre original de la categoría (en este idioma)',
    missing_source_labels_title: 'Categorías creadas en otro idioma: etiqueta en {{locale}}',
  },
  translations: {
    locale_fr: 'Francés',
    locale_en: 'Inglés',
    locale_es: 'Español',
    source_language_label: 'Escrito en (fijado una vez existan traducciones)',
    source_language_frozen:
      'El idioma de origen ya no se puede cambiar: ya existe al menos una traducción de este contenido.',
    tab_source: 'Origen',
    source_field_label: 'origen ({{locale}})',
    field_stale: 'origen modificado',
    field_optional: 'opcional',
    no_categories: 'No hay categorías que traducir para esta investigación.',
    badge_missing: '{{count}} faltante(s)',
    badge_stale: 'origen modificado',
    badge_complete: 'completo',
    dashboard_title: 'Panel de traducciones',
    dashboard_subtitle:
      'Investigaciones publicadas y su nivel de completitud por idioma — lo que falta traducir.',
    dashboard_col_investigation: 'Investigación',
    dashboard_col_locale: 'Idioma',
    dashboard_col_status: 'Estado',
    dashboard_col_missing: 'Campos faltantes',
    dashboard_col_stale: 'Campos obsoletos',
    dashboard_empty: 'Aún no hay investigaciones publicadas.',
    dashboard_edit_link: 'Editar',
    dashboard_export_action: 'Exportar',
    dashboard_import_action: 'Importar',
    dashboard_import_in_progress: 'Importando…',
    dashboard_import_in_progress_percent: 'Importando… {{percent}}%',
    dashboard_export_error: 'Error al exportar las traducciones',
    dashboard_import_error: 'Error al importar las traducciones',
    dashboard_import_invalid_file: 'Solo se permiten archivos JSON',
    dashboard_import_result_title: 'Importación completada',
    dashboard_import_updated:
      '{{investigations}} investigación(es), {{leads}} pista(s) y {{facts}} hecho(s) actualizados.',
    dashboard_import_skipped_title: 'Elementos omitidos (eliminados desde la exportación)',
    dashboard_import_errors_title: 'Algunos elementos no se pudieron importar',
    dashboard_import_close: 'Cerrar',
    detail_investigation_title: 'Detalle de la investigación',
    detail_investigation_subtitle: 'Completitud de traducciones por pista.',
    detail_lead_title: 'Detalle de la pista',
    detail_lead_subtitle: 'Completitud de traducciones por hecho.',
    detail_col_lead: 'Pista',
    detail_col_fact: 'Hecho',
    detail_row_investigation_own: 'Campos de la investigación',
    detail_row_lead_own: 'Campos de la pista',
    detail_leads_empty: 'Esta investigación no tiene pistas todavía.',
    detail_facts_empty: 'Esta pista no tiene hechos todavía.',
    detail_back_to_dashboard: 'Volver al panel',
    detail_back_to_investigation: 'Volver a la investigación',
    detail_not_found: 'No encontrado.',
    detail_edit_lead_aria: 'Editar pista {{title}}',
    detail_edit_fact_aria: 'Editar hecho {{title}}',
  },
}
